
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react'

import { eventLog } from './eventHelper';

// Components.
import HighlightSearchResults from './HighlightSearchResults';
import EpisodeSearchResults from './EpisodeSearchResults';
import { CloseRounded } from '@mui/icons-material';
import { SegmentedTabPanels } from './SegmentedTabs';
import useSearchResultsSelection from './useSearchResultsSelection';

const HIGHLIGHT_EPISODE_TAB_OPTIONS = [
    { value: 'highlights', label: 'Highlights' },
    { value: 'episodes', label: 'Episodes' },
];

const AlgoliaPodcastSearch = ({
    podcast,
    initialQuery,
    noQueryView,
    renderSearchInput,
    searchIntentKey = 0,
    initialResultsTab = 'highlights',

    // Redux.
}) => {
    const navigate = useNavigate();
    const scrollTargetRef = useRef(null);
    const options = Array.isArray(podcast.previews) && podcast.previews.length === 0
        ? HIGHLIGHT_EPISODE_TAB_OPTIONS.filter(option => option.value === 'episodes')
        : HIGHLIGHT_EPISODE_TAB_OPTIONS;
    const selection = useSearchResultsSelection(JSON.stringify([podcast.id, searchIntentKey]), initialResultsTab, options);
    const dockedControlsHeight = renderSearchInput && options.length > 1 ? 52 : 0;

    useEffect(() => {
        if (!!initialQuery) {
            eventLog(13, {
                'topicId': initialQuery,
            });
        }
    }, [initialQuery]);

    const query = (initialQuery || '').trim();

    useEffect(() => {
        document.getElementById('audio')?.pause();
    }, [query, podcast.id]);

    const searchAllPodcasts = () => {
        navigate('/search/' + encodeURIComponent(query));
    }

    return (
        <div>
            {renderSearchInput?.({ options, ...selection })}
            {!!query ?
                <div style={{ padding: '0px 0px 20px 0px' }}>
                    <div ref={scrollTargetRef} style={{ paddingTop: `${72 + dockedControlsHeight}px` }} />
                    <div className='scopedSearchHeader'>
                        <button onClick={searchAllPodcasts} className='clampSafeButton scopedSearchFilterChip scopedSearchFilterChipPodcast'>
                            <img className="podcastArtwork" alt={podcast.name} src={podcast.imageURL} style={{ width: '28px', height: '28px', objectFit: 'contain', flexShrink: 0 }} />
                            <span className='oneline scopedSearchFilterChipLabel'>
                                    {podcast.name}
                            </span>
                            <CloseRounded className='scopedSearchFilterChipClose' style={{ fontSize: '18px' }} />
                        </button>
                    </div>
                    <SegmentedTabPanels
                        resetKey={podcast.id}
                        scrollResetKey={JSON.stringify([query, podcast.id])}
                        {...selection}
                        hideSingleOption
                        hideControls={!!renderSearchInput}
                        scrollTargetRef={scrollTargetRef}
                        stickyControlTop='74px'
                        options={options}
                        panels={{
                            highlights: <HighlightSearchResults query={query} podcastId={podcast.id} entityName={podcast.name} onSearchEpisodes={() => selection.onChange('episodes')} />,
                            episodes: <EpisodeSearchResults query={query} podcastId={podcast.id} entityName={podcast.name} />,
                        }}
                        controlPadding='14px 20px 10px'
                        fontSize='14px'
                        buttonPadding='6px 0px'
                    />
                </div>
                :
                <div style={dockedControlsHeight ? { paddingTop: `${dockedControlsHeight}px` } : undefined}>
                    {noQueryView}
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(AlgoliaPodcastSearch);
